var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08332 7.03169C9.08332 5.88063 8.15063 4.94794 7.00041 4.94794C5.84935 4.94794 4.91666 5.88063 4.91666 7.03169C4.91666 8.18191 5.84935 9.1146 7.00041 9.1146C8.15063 9.1146 9.08332 8.18191 9.08332 7.03169Z",
    stroke: "#F87A08",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99959 15.7812C6.00086 15.7812 0.75 11.5299 0.75 7.08399C0.75 3.60345 3.54758 0.78125 6.99959 0.78125C10.4516 0.78125 13.25 3.60345 13.25 7.08399C13.25 11.5299 7.99832 15.7812 6.99959 15.7812Z",
    stroke: "#F87A08",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.d9d45ec3e3143f06c2c9ff6c40ea5231.svg";
export { ForwardRef as ReactComponent };